import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
    DomoPassport,
    DomoLoadState,
    DomoPassportFormState,
    DomoPassportID,
    DomoPassportHeader,
    initDomoPassport,
} from "userful-chronos-app-common-js/dist/models/integration/domo";
import {
    requestListPassports,
    requestAddPassport,
    requestRemovePassport,
    requestUpdatePassport,
} from "./msgs/domoMsgSender";

const initialState: {
    domoPassports: DomoPassport[];
    loadState: DomoLoadState;
    passport: DomoPassport;
    copyPassport: DomoPassport;
    formType: DomoPassportFormState;
    openForm: boolean;
} = {
    domoPassports: [],
    loadState: "RENDER",
    passport: initDomoPassport(),
    copyPassport: initDomoPassport(),
    formType: "Create",
    openForm: false,
};

export const domoSlice = createSlice({
    name: "domoSlice",
    initialState,
    reducers: {
        setPassports: (state, action: PayloadAction<DomoPassport[]>) => {
            state.domoPassports = action.payload;
        },
        addOrUpdatePassport: (state, action: PayloadAction<DomoPassport>) => {
            const foundIndex = state.domoPassports.findIndex((item) => item.id.value === action.payload.id.value);
            if (foundIndex < 0) {
                state.domoPassports = [...state.domoPassports, { ...action.payload }];
            } else {
                state.domoPassports = [
                    ...state.domoPassports.slice(0, foundIndex),
                    { ...action.payload },
                    ...state.domoPassports.slice(foundIndex + 1),
                ];
            }
        },
        removePassport: (state, action: PayloadAction<DomoPassportID>) => {
            state.domoPassports = state.domoPassports.filter((item) => item.id.value !== action.payload.value);
        },
        getPassportsFromServer: (state, action: PayloadAction<{}>) => {
            requestListPassports();
        },
        addPassportToServer: (state, action: PayloadAction<DomoPassportHeader>) => {
            requestAddPassport(action.payload);
        },
        updatePassportToServer: (state, action: PayloadAction<DomoPassportHeader>) => {
            requestUpdatePassport(action.payload);
        },
        removePassportToServer: (state, action: PayloadAction<DomoPassportID>) => {
            requestRemovePassport(action.payload);
        },
        changeLoadState: (state, action: PayloadAction<DomoLoadState>) => {
            state.loadState = action.payload;
        },
        setPassport: (state, action: PayloadAction<DomoPassport>) => {
            state.passport = action.payload;
        },
        setCopyPassport: (state, action: PayloadAction<DomoPassport>) => {
            state.copyPassport = action.payload;
        },
        setFormType: (state, action: PayloadAction<DomoPassportFormState>) => {
            state.formType = action.payload;
        },
        setOpenForm: (state, action: PayloadAction<boolean>) => {
            state.openForm = action.payload;
        },
    },
});

export const domoActions = domoSlice.actions;

export default domoSlice.reducer;
